
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { moneyFormat } from "@/utils/util";
import moment from "moment";
import ActivitySelect from "@/components/ActivitySelect/index.vue";
import { Getter } from "vuex-class";
import RealTimePopularity from "./components/RealTimePopularity.vue";
import DuringPeriod from "./components/DuringPeriod.vue";
import LongTimePeriod from "./components/LongTimePeriod.vue";
import { getActivityList, getActivityTraceRealTimePopularityDrawPeople, getActivityTraceRealTimePopularityDrawNumber, getActivityTraceRealTimePopularityDraw, getActivityTraceRealTimePopularityDrawWriteOffDate,getActivityTraceRealTimePopularityBudgetQuery, getActivityPeriodRevenuePullCostStatistics, getActivityPeriodRevenuePullConsumptionData, getActivityPeriodRevenuePullConsumptionDataDtl } from "@/api/shouyin";

@Component({
  components: { ActivitySelect, RealTimePopularity, DuringPeriod, LongTimePeriod },
})
export default class ActivityDetail extends Vue {
  moneyFormat = moneyFormat;
  @Getter companyId!: string;
  @Getter isMultiStore!: boolean;
  @Getter multiStoreList!: Array<any>;
  
  active = 0;
  chooseDataTab = ''
  
  RealTimeData = {
    lotteryId: '',
    drawWriteOffList: [],
    budgetUsed:'',
    generalBudget: '',
    paramsLine : { 
      lineName: "", 
      xData: [], 
      yData: [], 
      legendList: ["已抽奖人数", "可抽奖人数", "参考目标（基于上期活动）"],
      type: 1,
      xAxisData: ["合计", "消费赠送", "首单满赠", "积分兑换"],
      referenceTarget: 0,
      proposal: '',
      empty: true
    },
    paramsLine1 : { 
      lineName: "", 
      xData: [], 
      yData: [], 
      legendList: ["已抽奖次数", "可抽奖次数", "参考目标（基于上期活动）"],
      type: 2,
      xAxisData: ["合计", "消费赠送", "首单满赠", "积分兑换"],
      referenceTarget: 0,
      empty: true
    },
    paramsArea : { 
      lineName: "", 
      xData: [], 
      yData: {
        topData: [],
        bottomData: []
      }, 
      legendList: ["中奖数", "抽奖数"],
      type: 2,
      proposal: '',
      empty: true,
      from: 'real'
    }
  };
  
  DuringTimeData = {
    paramsArea : { 
      lineName: "", 
      xData: [], 
      yData: {
        topData: [],
        bottomData: []
      }, 
      legendList: ["兑奖会员消费额", "可抽奖会员消费额"],
      type: 2
    },
    costList: [],
    costMap: {},
    orderDetail: {},
    empty: true,
    from: 'during'
  };

  LongTimeData = {
    // paramsLine: {
    //   lineName: "兑奖会员消费金额",
    //   xData: [],
    //   yData: [],
    //   type: 2
    // },
    paramsArea : { 
      lineName: "", 
      xData: [], 
      yData: {
        topData: [],
        bottomData: []
      }, 
      legendList: ["兑奖会员消费额", "可抽奖会员消费额"],
      type: 2
    },
    otherData: {},
    empty: true
  }
  options = []
  
  lotteryName = ""; 
  lotteryId = ''
  showTotal = true;
  activityStarttime = null;
  activityEndtime = null; 
  popShow = false;
  
  params: any = {
    startTime: null,
    endTime: null,
    lotteryId: "",
    lotteryName: "",
    activityTime: null,
    storeId: this.companyId
  };
  
  minDate = null;
  maxDate = null;
  nowDate  = moment().toDate();
  currentDate = new Date();
  selectedDate = '';
  clearType = 1

  async mounted() {
    if (this.$route.query.activityName && this.$route.query.lotteryId) {
      this.lotteryName = this.$route.query.activityName as string;
      this.lotteryId = this.$route.query.lotteryId as string;
      this.activityStarttime = this.$route.query.lotteryStartTime as string;
      this.activityEndtime = this.$route.query.lotteryEndTime as string;
    }
    this.RealTimeData.lotteryId = this.lotteryId

    await this.getActivityListData();

    if (this.lotteryId) {
      this.getAllData();
    }
  }

  async getActivityListData() {
    try {
      const res: any = await getActivityList({ storeId: this.companyId });
      this.options = res.data.map((item) => {
        if (this.lotteryId) {
          const item = {
            lotteryStartTime: this.activityStarttime, 
            lotteryEndTime: this.activityEndtime
          } 
          this.setActivityInfo(item);
        } else if (!this.lotteryId && item.lotteryId === res.data[0].defaultLotteryId) {
          this.lotteryName = item.lotteryName;
          this.lotteryId = item.lotteryId;
          this.RealTimeData.lotteryId = this.lotteryId
          this.activityStarttime = item.lotteryStartTime;
          this.activityEndtime = item.lotteryEndTime;
          this.setActivityInfo(item);
        }

        const { lotteryName, lotteryId, ...other } = item;
        return {
          text: lotteryName,
          value: lotteryId,
          ...other
        };
      });
    } catch (err) {
      console.error("获取活动列表失败", err);
    }
  }

  setActivityInfo(item) {
    const startTime = moment(item.lotteryStartTime);
    const endTime = moment(item.lotteryEndTime);
    const nowDate = moment();
    
    this.params.startTime = startTime.format("YYYY-MM-DD");
    this.params.endTime = nowDate.isBefore(endTime) 
      ? nowDate.format("YYYY-MM-DD")
      : endTime.format("YYYY-MM-DD");
    this.params.activityTime = this.params.endTime;
    this.params.lotteryId = this.lotteryId;
    this.params.lotteryName = this.lotteryName;

    this.minDate = startTime.toDate();
    this.maxDate = nowDate.isBefore(endTime) 
      ? nowDate.toDate() 
      : endTime.toDate();
  }

  // 统一请求所有数据 —— 修复：支持所有标签页
  getAllData() {
    if (this.active === 0) {
      this.getActivityTraceRealTimePopularityDrawPeopleData();
      this.getActivityTraceRealTimePopularityDrawNumberData();
      this.getActivityTraceRealTimePopularityDrawData();
      this.getActivityTraceRealTimePopularityDrawWriteOffDate();
      this.getActivityTraceRealTimePopularityBudgetQuery()
    } else if (this.active === 1) {
      this.getActivityPeriodRevenuePullCostStatistics()
      this.getActivityPeriodRevenuePullConsumptionData()
    } else if (this.active === 2 && this.params.endTime) {
      this.getActivityPeriodRevenuePullConsumptionDataDtl()
    }
  }

  // 实时人气-已/可抽奖人数
  getActivityTraceRealTimePopularityDrawPeopleData(){
    if (!this.lotteryId) return;
    getActivityTraceRealTimePopularityDrawPeople({
      lotteryId: this.lotteryId,
      storeId: this.companyId,
      activityTime: this.params.endTime
    }).then((res: any) => {
      this.RealTimeData.paramsLine.xData = [res.data.alreadyTotal, res.data.alreadyconsumptionGift, res.data.alreadyfirstGift, res.data.alreadyCreditsExchange]
      this.RealTimeData.paramsLine.yData = [res.data.total, res.data.consumptionGift, res.data.firstGift, res.data.creditsExchange]
      this.RealTimeData.paramsLine.referenceTarget = res.data.referenceTarget || 0
      this.RealTimeData.paramsLine.proposal = res.data.proposal || ''
      this.RealTimeData.paramsLine.empty = this.RealTimeData.paramsLine.yData?.every((item) => Number(item) === 0)
      this.RealTimeData = { ...this.RealTimeData }
    }).catch(err => console.log("人数接口报错", err));
  }

  // 实时人气-已/可抽奖次数
  getActivityTraceRealTimePopularityDrawNumberData(){
    if (!this.params.lotteryId) return;
    getActivityTraceRealTimePopularityDrawNumber({
      lotteryId: this.lotteryId,
      storeId: this.companyId,
      activityTime: this.params.endTime
    }).then((res: any) => {
      this.RealTimeData.paramsLine1.xData = [res.data.alreadyTotalNumber || 0, res.data.alreadyconsumptionGiftNumber || 0, res.data.alreadyfirstGiftNumber || 0, res.data.alreadyCreditsExchangeNumber || 0]
      this.RealTimeData.paramsLine1.yData = [res.data.totalNumber || 0, res.data.consumptionGiftNumber || 0, res.data.firstGiftNumber || 0, res.data.creditsExchangeNumber || 0]
      this.RealTimeData.paramsLine1.referenceTarget = res.data.referenceTarget || 0
      this.RealTimeData.paramsLine1.empty = this.RealTimeData.paramsLine1.yData?.every((item) => Number(item) === 0)
      this.RealTimeData = { ...this.RealTimeData }
    }).catch(err => console.log("次数接口报错", err));
  }

  // 实时人气-中/抽奖数
  getActivityTraceRealTimePopularityDrawData(){
    if (!this.params.lotteryId) return;
    getActivityTraceRealTimePopularityDraw({
      lotteryId: this.lotteryId,
      storeId: this.companyId,
      activityTime: this.params.endTime
    }).then((res: any) => {
      this.RealTimeData.paramsArea.xData = res.data.xData
      const bottomData = this.fillDataByX('real', res.data.xData, res.data.yData.bottomData)
      const topData = this.fillDataByX('real', res.data.xData, res.data.yData.topData)
      this.RealTimeData.paramsArea.yData.bottomData = bottomData
      this.RealTimeData.paramsArea.yData.topData = topData
      this.RealTimeData.paramsArea.proposal = res.data.proposal || ''
      this.RealTimeData.paramsArea.empty = this.RealTimeData.paramsArea.yData.bottomData?.every((item) => item.createTime) || this.RealTimeData.paramsArea.yData.topData?.every((item) => item.createTime)
      this.RealTimeData = { ...this.RealTimeData }
    }).catch(err => console.log("抽奖数接口报错", err));
  }

  fillDataByX(type, xData, targetData) {
    return xData.map(date => {
      const item = targetData.find(item => item.createTime === date);
      // 区分是实时还是期间或者长期营收 real 是实时  during 是期间  long 是长期
      if(type === 'real'){
        return item ? item.count : 0;
      } else if(type === 'during') {
        return item ? item.orderMoney : 0;
      } else if(type === 'long'){
        return item ? item.orderMoney : 0;
      }
    });
  }

  // 实时人气-中奖&核销数据
  getActivityTraceRealTimePopularityDrawWriteOffDate(){
    if (!this.params.lotteryId) return;
    getActivityTraceRealTimePopularityDrawWriteOffDate({
      lotteryId: this.lotteryId,
      storeId: this.companyId,
      activityTime: this.params.endTime
    }).then((res: any) => {
      this.RealTimeData.drawWriteOffList = res.data
      this.RealTimeData = { ...this.RealTimeData }
    }).catch(err => console.log("核销接口报错", err));
  }

  // 获取中奖vs核销数的预算
  getActivityTraceRealTimePopularityBudgetQuery(){
    getActivityTraceRealTimePopularityBudgetQuery(
        {
          storeId: this.companyId,
          lotteryId: this.lotteryId
        }
      ).then((res: any) => {
        this.RealTimeData.budgetUsed = res.data.budgetUsed
        this.RealTimeData.generalBudget = res.data.generalBudget
      })
  }

  // 期间营收拉动-成本统计
  getActivityPeriodRevenuePullCostStatistics(){
    getActivityPeriodRevenuePullCostStatistics({
      storeId: this.companyId,
      lotteryId: this.lotteryId,
      activityTime: this.params.endTime
    }).then((res: any) => {
      this.DuringTimeData.costList = res.data.costList
      this.DuringTimeData.costMap = res.data.costMap
    })
  }

  // 期间营收拉动-消费数据
  getActivityPeriodRevenuePullConsumptionData() {
    if (!this.params.lotteryId) return;
    getActivityPeriodRevenuePullConsumptionData({
      lotteryId: this.lotteryId,
      storeId: this.companyId,
      activityTime: this.params.endTime
    }).then((res: any) => {
      const {xData,yData, ...other} = res.data
      this.DuringTimeData.paramsArea.xData = res.data.xData
      const bottomData = this.fillDataByX('during', res.data.xData, res.data.yData.bottomData)
      const topData = this.fillDataByX('during', res.data.xData, res.data.yData.topData)
      this.DuringTimeData.paramsArea.yData.bottomData = bottomData
      this.DuringTimeData.paramsArea.yData.topData = topData
      this.DuringTimeData.orderDetail = {...other}
      this.DuringTimeData.empty = this.DuringTimeData.paramsArea.yData.bottomData?.every((item) => item.createTime) || this.DuringTimeData.paramsArea.yData.topData?.every((item) => item.createTime)
      this.DuringTimeData = { ...this.DuringTimeData }
    }).catch(err => console.log("活动期间消费数据接口报错", err));
  }

  // 长期营收拉动-消费数据
  getActivityPeriodRevenuePullConsumptionDataDtl() {
    if (!this.params.lotteryId || !this.params.endTime) return;
    getActivityPeriodRevenuePullConsumptionDataDtl({
      lotteryId: this.lotteryId,
      storeId: this.companyId,
      activityTime: !this.chooseDataTab ? this.params.endTime : this.chooseDataTab === 'week' ? 1 : 2
    }).then((res: any) => {
      const {dataList, ...otherData} = res.data
      const createTime = dataList.map((item: any) => item.createTime)
      const orderMoney = createTime.map(date => {
        const item = dataList.find(item => item.createTime === date)
        return item?.orderMoney || 0
      });
      // this.LongTimeData.paramsLine.xData = createTime
      // this.LongTimeData.paramsLine.yData = orderMoney
      // this.LongTimeData.otherData = {...otherData}
      // this.LongTimeData.empty = this.LongTimeData.paramsLine.yData?.every((item) => Number(item) === 0);
      this.LongTimeData.paramsArea.xData = res.data.xData
      const bottomData = this.fillDataByX('long', res.data.xData, res.data.yData.bottomData)
      const topData = this.fillDataByX('long', res.data.xData, res.data.yData.topData)
      this.LongTimeData.paramsArea.yData.bottomData = bottomData
      this.LongTimeData.paramsArea.yData.topData = topData
      this.LongTimeData.otherData = {...otherData}
      this.LongTimeData.empty = this.LongTimeData.paramsArea.yData.bottomData?.every((item) => item.createTime) || this.LongTimeData.paramsArea.yData.topData?.every((item) => item.createTime)
      this.LongTimeData = { ...this.LongTimeData }
    }).catch(err => console.log("长期营收拉动-消费数据接口报错", err));
  }

  formatter(type, value) {
    if (type === 'year') return `${value}年`;
    if (type === 'month') return `${value}月`;
    if (type === 'day') return `${value}日`;
    return value;
  };

  onConfirm(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    this.selectedDate = `${year}-${month}-${day}`;
    this.params.endTime = this.selectedDate;
    this.popShow = false;
    this.chooseDataTab = ''
    this.getAllData()
  };

  @Watch("params", { deep: true, immediate: true })
  onParamsChange() {
    if (this.lotteryId && this.params.endTime) {
      this.getAllData();
    }
  }

  @Watch("active", { deep: true, immediate: true })
  onChangeTabs() {
    this.RealTimeData = {
      ...this.RealTimeData,
      paramsLine: { ...this.RealTimeData.paramsLine, empty: true },
      paramsLine1: { ...this.RealTimeData.paramsLine1, empty: true },
      paramsArea: { ...this.RealTimeData.paramsArea, empty: true },
    };
    this.DuringTimeData = { ...this.DuringTimeData, empty: true };
    this.LongTimeData = { ...this.LongTimeData, empty: true };
    if (!this.activityStarttime) return;
    this.chooseDataTab = '';
    this.params.startTime = moment(this.activityStarttime).format("YYYY-MM-DD");
    const item = {
        lotteryStartTime: this.activityStarttime, 
        lotteryEndTime: this.activityEndtime
      }
    if (this.active === 2) {
        this.changeDate('week')
    } else {
      this.setActivityInfo(item)
      this.getAllData()
    }
  }

  // 一周/一月时间处理
  changeDate(type:string) {
    this.chooseDataTab = type;
    const activityEndMoment = moment(this.activityEndtime).clone();
    if (type === 'week') {
      this.params.startTime = activityEndMoment.add(1, 'days').format("YYYY-MM-DD");
      this.params.endTime = activityEndMoment.add(7, 'days').format("YYYY-MM-DD");
      // if (this.clearType === 2) {
      //   this.chooseDataTab = '';
      // }
    } else if (type === 'month') {
      this.params.startTime = activityEndMoment.add(1, 'days').format("YYYY-MM-DD");
      this.params.endTime = activityEndMoment.add(1, 'months').format("YYYY-MM-DD");
    }
    this.minDate = moment(this.params.startTime).toDate();
    this.maxDate = moment(this.params.endTime).toDate();
    this.getActivityPeriodRevenuePullConsumptionDataDtl()
  }

  onSearchConfirm(res) {
    console.log(333111, res)
    this.lotteryName = res.text;
    this.lotteryId = res.value;
    this.params.lotteryName = res.text;
    this.params.lotteryId = res.value;
    this.RealTimeData.lotteryId = this.lotteryId
    this.activityStarttime = res.lotteryStartTime;
    this.activityEndtime = res.lotteryEndTime;
    if (this.active === 2) {
      this.clearType = 2
      this.changeDate('week')
      return
    }
    this.setActivityInfo(res)
  }
  
}
